import { useSelector } from 'react-redux';
import { getIsViewProfileAsVisitor } from '../../redux/users/selectors';
export function useIsProfileVisitorMode() {
    // this is done this way to allow Dumbo blurring in visitor mode on profiles
    // we told product that it's a hack and will be a brittle implementation as we move forward
    return useSelector(getIsViewProfileAsVisitor);
}
//# sourceMappingURL=useIsProfileVisitorMode.js.map